import { Component, Input, OnInit, Output, TemplateRef, EventEmitter } from '@angular/core';
import { Margin, Padding } from '../types/type';

@Component({
  selector: 'custom-accordion',
  templateUrl: './custom-accordion.component.html',
  styleUrls: ['./custom-accordion.component.scss']
})
export class CustomAccordionComponent implements OnInit {

  @Input() label: string;
  @Input() iconSrc: string;
  @Input() assistiveText: string;
  @Input() disabled: boolean = false;
  @Input() isExpanded: boolean = false;
  @Input() margin: Margin = 'medium';
  @Input() padding: Padding = 'medium';
  @Input() tabIndexValue: number = 0;
  @Input() childTemplate: TemplateRef<any>;

  @Output() onClick = new EventEmitter();

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }

  onItemClick(event) {
    this.onClick.emit(event);
  }

}
